import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "../components/ui/card";
import { Lightbulb } from "lucide-react";

export function AdvisorPage() {
  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <div className="flex items-center gap-3">
            <div className="p-2 bg-blue-500/10 rounded-lg">
              <Lightbulb className="h-6 w-6 text-blue-400" />
            </div>
            <div>
              <CardTitle>Advisor</CardTitle>
              <CardDescription>
                Get insights and recommendations based on statistical analysis
              </CardDescription>
            </div>
          </div>
        </CardHeader>
        <CardContent>
          <div className="flex flex-col items-center justify-center py-12 text-center">
            <div className="p-4 bg-secondary rounded-full mb-4">
              <Lightbulb className="h-12 w-12 text-muted-foreground" />
            </div>
            <h3 className="text-lg font-semibold mb-2">Coming Soon</h3>
            <p className="text-muted-foreground max-w-md">
              The advisor will provide statistical insights about optimal
              play timing and probability analysis based on historical data.
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
